import {
  type UPDATE_TYPES,
  GetProfileChangeLogsFilter,
} from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";
import { endOfDay, startOfDay } from "date-fns";

export interface BuildFilterInput {
  debouncedEmail: string;
  debouncedUpdatedFieldKey: string;
  updateType: UPDATE_TYPES | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
}

export function buildFilter(input: BuildFilterInput): GetProfileChangeLogsFilter | undefined {
  const trimmedEmail = input.debouncedEmail.trim();
  const trimmedUpdatedFieldKey = input.debouncedUpdatedFieldKey.trim();
  const filter: NonNullable<GetProfileChangeLogsFilter> = {};

  if (trimmedEmail.length > 0) {
    filter.performedByEmail = trimmedEmail;
  }
  if (trimmedUpdatedFieldKey.length > 0) {
    filter.updatedFieldKey = trimmedUpdatedFieldKey;
  }
  if (isDefined(input.updateType)) {
    filter.updateType = input.updateType;
  }
  if (isDefined(input.startDate)) {
    filter.startDate = startOfDay(input.startDate).toISOString();
  }
  if (isDefined(input.endDate)) {
    filter.endDate = endOfDay(input.endDate).toISOString();
  }

  return Object.keys(filter).length === 0 ? undefined : filter;
}

export function isFilterActive(filter: GetProfileChangeLogsFilter | undefined): boolean {
  return isDefined(filter);
}
